import { render, staticRenderFns } from "./QuotesTableSkeleton.vue?vue&type=template&id=6888c86a&scoped=true&"
import script from "./QuotesTableSkeleton.vue?vue&type=script&lang=js&"
export * from "./QuotesTableSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./QuotesTableSkeleton.vue?vue&type=style&index=0&id=6888c86a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6888c86a",
  null
  
)

export default component.exports